<template>
  <el-row class="route-unit" style="height: 30px; overflow: hidden">
    <el-col :sm="3" class="time-sign" :style="statusStyle" :title="routeInfo">
      <span v-show="route.showTime || previewMode">{{
        intToTime(route.startTimeMM)
      }}</span>
      <span
        v-show="route && route.weight && route.weight.timeBeThere"
        class="quoted"
      >
        <fa icon="arrow-left"></fa>
        {{
          route.weight && route.weight.timeBeThere
            ? intToTime(route.weight.timeBeThere)
            : null
        }}
      </span>

      <fa
        size="lg"
        style="margin-right: 10%; color: white; float: right"
        :icon="statusIcon"
      ></fa>
    </el-col>
    <el-col :span="21">
      <el-row class="route-info">
        <el-col :sm="6" :class="tripClass">
          <fa :icon="tripIcon"></fa>
          <el-badge :value="route.pax" title="pax" type="primary"></el-badge>
          <span type="info" :title="route.coname">{{ route.flight }}</span>
          <span class="small">{{ route.distributors }}</span>
        </el-col>
        <el-col :sm="4">
          <el-tag
            closable
            v-if="route.transmean"
            @close="$emit('removeVehicle', route)"
            >{{ route.transmean }}</el-tag
          >
          <el-tag type="warning" v-if="route.bussign" title="bus sign">{{
            route.bussign
          }}</el-tag>
        </el-col>
        <el-col :sm="1" title="Escort" class="small">{{
          route.escort_name
        }}</el-col>
        <el-col :title="route.loc_seq_trans" :sm="9">
          <el-tag effect="dark" type="primary">{{ route.pupnameA }}</el-tag>
          <!-- <p>{{route.execLog}}</p> -->
          <el-tag
            v-for="(locdata, loc) in route.execLog"
            :key="loc"
            :value="locdata.time ? formatUnxTime(locdata.time, true) : ''"
            type="primary"
          >
            <el-tag v-if="locdata.time" type="warning">{{
              formatUnxTime(locdata.time, true)
            }}</el-tag>
            {{ locdata.code }}
          </el-tag>
          <small>
            <fa icon="angle-double-right"></fa>
            {{ intToTime(route.endTimeMM) }}
          </small>
        </el-col>
        <el-col :sm="2">
          <span class="small" :title="route.distributors">{{
            route.coname
          }}</span>
        </el-col>
        <el-col :sm="2" title="Comments" class="small">{{
          route.comments
        }}</el-col>
        <!-- <el-col v-else :sm="11">
          {{route.loc_seq_trans}}
          <small>
            <fa icon="angle-double-right"></fa>
            {{intToTime(route.endTimeMM)}}
          </small>
          <el-tooltip
            class="item"
            effect="dark"
            :content="route.comments"
            placement="top-end"
            style="float:right"
          >
            <fa icon="comment-alt" v-if="route.comments&&route.comments!=''" style="float:right"></fa>
          </el-tooltip>
        </el-col>-->
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { fetchList } from "~/api/resource";
import { mapGetters } from "vuex";
// :class="{'route-unit':true,'not-available':(route.weight.hard>0),'expired':(route.weight.soft<0)}"
export default {
  name: "routing-route",
  props: {
    previewMode: { type: Boolean, default: false },
    routeData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    routeInfo() {
      let msg = this.route.driverName;
      if (this.route.ntf_update) {
        if (this.route.ntf_update.timeInteractedHuman)
          msg += " show " + this.route.ntf_update.timeInteractedHuman;
        msg += " sent " + this.route.ntf_update.timeSentHuman;
      }
      return msg;
    },
    statusIcon() {
      // _log_("style ROUTWE..." + this.route.id, this.route);
      if (this.route.isDone == "sure") return "check-square";

      if (this.route.ntf_update) {
        if (this.route.ntf_update.timeInteracted) return "envelope-open-text";
        if (this.route.ntf_update.timeReceived) return "envelope-square";
        if (this.route.ntf_update.timeSent) return "envelope";
      }
      if (this.route.isDone == "maybe") return "calendar-check";
      return "pause-circle";
    },
    statusStyle() {
      let c = "#095b69";
      if (this.route.isDone == "sure") c = "#409eff7a";

      if (this.route.ntf_update) {
        if (this.route.ntf_update.timeInteracted) c = "#409eff";
        else if (this.route.ntf_update.timeReceived) c = "#e6a23c";
        else if (this.route.ntf_update.timeSent) c = "#f56c6c";
      } else if (this.route.isDone == "maybe") c = "#00968861";
      return "background:" + c;
    },
    // isDone() {
    //   var maybe = false,
    //     now = new Date(),
    //     propableEnd = now.getHours() * 60 + now.getMinutes();
    //   if (
    //     this.route.endTimeMM &&
    //     this.route.endTimeMM + (this.tripIcon == "plane-arrival" ? 60 : 30) <
    //       propableEnd
    //   )
    //     maybe = true;
    //   if (this.route.execLog) {
    //     const last = this.route.execLog[this.route.execLog.length - 1];
    //     if (last && last.time && last.time != "0") return "sure";
    //   }
    //   return maybe ? "maybe" : "";
    // },
    tripIcon() {
      // _log_('>>>',this.routeData.loc_seq_trans,this.routeData.loc_seq_trans.indexOf('AIR'))
      if (this.routeData.destination == "PICKUP") return "walking";
      if (this.routeData.destination == "EXCRS") return "ship";
      // if (this.routeData.loc_seq_trans.indexOf("AIR") === 0)
      if (this.routeData.direction == "ARV") return "plane-arrival";
      // if (this.routeData.loc_seq_trans.indexOf("AIR") > 3)
      if (this.routeData.direction == "DEP") return "plane-departure";
      return "bug";
    },
    tripClass() {
      if (this.routeData.destination == "PICKUP") return "pickup";
      if (this.routeData.destination == "EXCRS") return "excrs";
      if (this.routeData.direction == "DEP") return "departure";
      if (this.routeData.direction == "ARV") return "arrival";
      // if (this.routeData.loc_seq_trans.indexOf("AIR") === 0) return "arrival";
      // if (this.routeData.loc_seq_trans.indexOf("AIR") > 3) return "departure";
      return "error";
    },
  },
  // watch: {
  //   // "routeData.weight.soft": function(newValue) {
  //   //   this.route.weight.soft = newValue;
  //   //   _log_("nnr..eessss.", newValue);
  //   //   // this.$set(this.$data, 'route' , newValue);
  //   // },
  //   "routeData.weight": {
  //     handler: newValue => {
  //       _log_("nnr...", newValue);

  //       // this.$set(this.$data, "route", newValue);
  //     },
  //     deep: true
  //     // immediate:true
  //   }
  // },
  data() {
    return {
      route: this.routeData,
    };
  },
  // created() {
  //   this.route = this.routeData;
  // }
};
</script>
<style>
.item {
  margin-top: 10px;
  margin-right: 40px;
}
span.quoted {
  font-size: 9px;
}
.route-unit .pickup {
  background-color: burlywood;
}
.route-unit .excrs {
  background-color: #06616b;
}
.route-unit .arrival {
  border-top-left-radius: 30%;
  border-bottom-left-radius: 30%;
  background-color: darkcyan;
  color: aliceblue;
}
.route-unit .departure {
  border-top-right-radius: 30%;
  border-bottom-right-radius: 30%;
  background-color: darkmagenta;
  color: aliceblue;
}
.levelA .route-unit .route-info {
  border: 4px solid rgb(112, 4, 4);
}
/* .route-unit.expired {
  border: 2px solid rgb(112, 4, 4);
} */
.levelC .route-unit {
  background-color: rgba(153, 123, 123, 0.2);
  opacity: 0.9;
}
.route-unit .route-info {
  border: 1px solid green;
  border-top-right-radius: 5px;
  padding: 3px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.time-sign {
  background-color: darkgreen;
  color: white;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.levelA .route-unit .time-sign {
  background-color: rgb(112, 4, 4);
}
.levelC .route-unit .time-sign {
  background-color: grey;
}
.route-unit .small {
  color: grey;
  font-weight: bold;
  font-size: 10px;
}
.time-sign span.quoted {
  color: white;
}
</style>
